<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('instructor_exam_request_admin')"
                        @filter-div-status="datatable.filterStatus = $event"
                        :otherButton="prepareEntryObj"
                        @prepareEntry="prepareEntryModal">
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('instructor_exam_request_admin')"
                              @filter-div-status="datatable.filterStatus = $event"
                              :otherButton="prepareEntryObj"
                              @prepareEntry="prepareEntryModal">
                </HeaderMobile>
            </template>
            <datatable-filter
                v-show="datatable.filterStatus"
                @filter="filter"
                @filterClear="filterClear"
                :export-excel="checkPermission('instructorexamrequest_excelexport')"
                @exportExcel="downloadExcel"
            >
                <b-row>
                    <b-col sm="4">
                        <b-form-group :label="$t('id')">
                            <b-form-input v-model="datatable.queryParams.filter.id">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="4">
                        <b-form-group :label="$t('teaching_staff')">
                            <staff-auto-complete
                                v-model="datatable.queryParams.filter.instructor_id"></staff-auto-complete>
                        </b-form-group>
                    </b-col>
                    <b-col sm="4">
                        <b-form-group :label="$t('period')">
                            <semesters-selectbox
                                v-model="datatable.queryParams.filter.semester_id"></semesters-selectbox>
                        </b-form-group>
                    </b-col>
                    <b-col md="6" lg="4">
                        <b-form-group :label="$t('exam_type')">
                            <parameter-selectbox
                                v-model="datatable.queryParams.filter.exam_type"
                                code="exam_schedules_types"/>
                        </b-form-group>
                    </b-col>
                    <b-col md="6" lg="4">
                        <b-form-group :label="$t('is_in_program')">
                            <parameter-selectbox
                                code="instructor_exam_request_statuses"
                                v-model="datatable.queryParams.filter.status"
                            ></parameter-selectbox>
                        </b-form-group>
                    </b-col>
                    <b-col md="6" lg="4">
                        <b-form-group :label="$t('faculty')">
                            <faculty-selectbox v-model="datatable.queryParams.filter.faculty_code"></faculty-selectbox>
                        </b-form-group>
                    </b-col>
                    <b-col md="6" lg="4">
                        <b-form-group :label="$t('course_code')">
                            <b-form-input v-model="datatable.queryParams.filter.course_code"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </datatable-filter>
            <datatable
                :isLoading.sync="datatable.isLoading"
                :columns="datatable.columns"
                :rows="datatable.rows"
                :total="datatable.total"
                :queryParams="datatable.queryParams"
                :lineNumbers="false"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-per-page-change="onPerPageChange"
                v-show="datatable.showTable"
            >
            </datatable>
            <CommonModal ref="updateFormModal" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="formClear"
                         v-if="checkPermission('instructorexamrequest_update')">
                <template v-slot:CommonModalTitle>
                    {{ $t('edit').toLocaleUpperCase('tr-TR') }}
                </template>
                <template v-slot:CommonModalContent>
                    <update-form :formId="formId"
                                 @updateFormSuccess="updateFormSuccess"
                                 v-if="formProcess=='update'"/>
                </template>
            </CommonModal>
            <CommonModal ref="prepareEntry" size="sm" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('prepare_entry').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <div class="d-flex flex-column">
                        <b-button
                            variant="success"
                            class="m-2"
                            :disabled="formLoading"
                            @click="prepareEntry('midterm')"
                        >
                            {{ $t('midterm') }}
                        </b-button>

                        <b-button
                            variant="info"
                            class="m-2"
                            :disabled="formLoading"
                            @click="prepareEntry('final')"
                        >
                            {{ $t('final') }}
                        </b-button>

                    </div>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
//Template
import AppLayout from "@/layouts/AppLayout";
import Header from "@/layouts/AppLayout/Header"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"

//Component
import DatatableFilter from "@/components/datatable/DatatableFilter";
import Datatable from "@/components/datatable/Datatable";
import CommonModal from "@/components/elements/CommonModal";
import FacultySelectbox from '@/components/interactive-fields/FacultySelectbox';

//Service
import instructorExamRequestAdminService from "@/services/instructorExamRequestAdminService";
//Page
import UpdateForm from "./UpdateForm"
//Other
import qs from "qs";
import i18n from "@/plugins/i18n";

export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,

        DatatableFilter,
        Datatable,
        CommonModal,
        FacultySelectbox,

        UpdateForm
    },
    metaInfo() {
        return {
            title: this.$t("instructor_exam_request_admin"),
        };
    },
    data() {
        return {
            formId: 0,
            form: {},
            formProcess: null,
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: "",
                        field: "buttons",
                        html: true,
                        sortable: false,
                        tdClass: "p-0 text-center w-40 align-middle",
                        buttons: [
                            {
                                text: this.$t("edit"),
                                class: "ri-edit-box-line",
                                permission: 'instructorexamrequest_update',
                                callback: (row) => {
                                    this.loadData(row);
                                },
                            },
                            {
                                text: this.$t('delete'),
                                class: 'ri-delete-bin-7-line',
                                //permission: "instructorexamrequest_delete",
                                callback: (row) => {
                                    this.deleteRequest(row.id)
                                }
                            }
                        ],
                    },
                    {
                        label: this.$t("exam_type"),
                        field: this.getLocaleField("exam_type_name"),
                        sortable: true,
                    },
                    {
                        label: this.$t("course_code"),
                        field: "course_code",
                        sortable: true,
                    },
                    {
                        label: this.$t("course_name"),
                        field: "course_name",
                        sortable: true,
                    },
                    {
                        label: this.$t("teaching_staff"),
                        field: "instructor_name",
                        sortable: true,
                        formatFn: (value, row) => {
                            return row.instructor_name + " " + row.instructor_surname;
                        },
                    },
                    {
                        label: this.$t("academic_year"),
                        field: "semester",
                        sortable: false,
                        hidden: false,
                        formatFn: (value, row) => {
                            return row.semester.academic_year + ' / ' + this.getSemester(row.semester.semester)
                        }
                    },
                    {
                        label: this.$t("section_1").toLocaleUpperCase('en-EN'),
                        field: "section",
                        sortable: true,
                    },
                    {
                        label: this.$t("private_classroom"),
                        field: this.getLocaleField("classroom_type_name"),
                        sortable: true,
                    },
                    {
                        label: this.$t("is_in_program"),
                        field: this.getLocaleField("status_name"),
                        sortable: true,
                    },
                    {
                        label: this.$t("explanation"),
                        field: "explanation",
                        sortable: true,
                    },
                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {},
                    sort: "id",
                    page: 1,
                    limit: 20,
                },
            },
            prepareEntryObj: {
                show: this.checkPermission('instructorexamrequest_prepareentry'),
                emit: 'prepareEntry',
                title: i18n.t('prepare_entry'),
                icon: 'ri-todo-line'
            },
            formLoading: false,
        };
    },
    mounted() {
        this.prepareEntryObj.show = this.checkPermission('instructorexamrequest_prepareentry')
    },
    methods: {
        filter() {
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        filterClear() {
            this.datatable.queryParams.filter = {};
            this.getRows();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        onSortChange(params) {
            const sortType = params[0].type == "desc" ? "-" : "";
            this.datatable.queryParams.sort = sortType + params[0].field;
            this.getRows();
        },
        getRows() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;

            const config = {
                params: {
                    ...this.datatable.queryParams
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };

            return instructorExamRequestAdminService.getAll(config)
                .then((response) => {
                    this.datatable.rows = response.data.data;
                    this.datatable.total = response.data.pagination.total;
                })
                .finally(() => {
                    this.datatable.isLoading = false;
                });
        },
        loadData(row) {
            this.formProcess = "update";
            this.formId = row.id
            this.$refs.updateFormModal.$refs.commonModal.show();
        },
        // Show
        showForm(id) {
            this.formId = id
            this.formProcess = 'show'
            this.$refs.showModal.$refs.commonModal.show()
        },
        async updateFormSuccess() {
            this.$refs.updateFormModal.$refs.commonModal.hide()
            this.getRows()
            this.formClear()
        },
        formClear() {
            this.formId = null
            this.formProcess = null
        },
        downloadExcel() {
            const config = {
                params: {
                    ...this.datatable.queryParams
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };
            instructorExamRequestAdminService.downloadAsExcel(config)
                .then(res => this._downloadFile(res, this.$t('instructor_exam_request') + '.xlsx'))
                .catch(err => this.showErrors(err))
        },
        prepareEntryModal() {
            this.formProcess = 'prepareEntry';
            this.$refs.prepareEntry.$refs.commonModal.show();
        },
        async prepareEntry(examType) {
            this.formLoading = true;

            instructorExamRequestAdminService.prepareEntry(examType)
                .then(response => {
                    this.$toast.success(this.$t('api.' + response.data.message));
                    this.$refs.prepareEntry.$refs.commonModal.hide();
                })
                .catch(e => {
                    this.showErrors(e, this.$refs.formModalValidate);
                })
                .finally(() => {
                    this.formLoading = false
                })
        },

        deleteRequest(rowId){
            this.$swal.fire({
                text: this.$t('are_you_sure_to_delete'),
                showCancelButton: true,
                confirmButtonText: this.$t('yes'),
                cancelButtonText: this.$t('no')
            }).then((result) => {
                if (result.isConfirmed) {
                    instructorExamRequestAdminService.remove(rowId).then(response => {
                        this.$toast.success(this.$t('api.' + response.data.message))
                        this.getRows()
                    }).catch(e => {
                        this.showErrors(e, null)
                    })
                }
            })
        }
    },
};
</script>
